import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-portal-check",
  "use": "icon-portal-check-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-portal-check\"><path d=\"m5.7484 12.93992 10.72786-10.72791 1.4241 1.42406-12.15197 12.15192-5.64876-5.64872 1.42405-1.42406 4.22471 4.22471z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol